import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faMailBulk } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Components
import TextField from '../../../components/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import EnviarCobrancaEmLote from '../DividaAtiva/components/EnviarCobrancaEmLote';

//API
import tipoDeFiscalizacao_api from '../../../api/tipoDeFIscalizacao_api';
import gereciamentoArrecadacao_api from '../../../api/gereciamentoArrecadacao_api';
import roteiroDeFiscalizacao_api from '../../../api/roteiroDeFiscalizacao_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';
import { criarOnChangeMultiSelect } from '../../../helpers/onChangeMultiSelect';
import mascaras from '../../../helpers/mascaras';

//Context
import { useAuth } from '../../../context/auth';

function initialStateConsulta() {
    const dataInicial = new Date();
    dataInicial.setMonth(dataInicial.getMonth() - 1);
    return {
        tipoBusca: 'Data de Infração',
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(new Date()).format("YYYY-MM-DD"),
        tipoFiscalizacao_Ids: [],
        numeroInfracao: "",
        logradouro: '',
        numero: '',
        bairro: '',
        nome: '',
        statusBoleto: 'Todos',
        roteiroFiscalizacaoEtapa_Id: "0"
    }
}

export default function EmissaoBoletosEmLote() {
    const { setLoading } = useAuth();

    //State do filtro de consulta
    const [consulta, setConsulta] = useState(initialStateConsulta());

    //State para pegar lista dos tipos de fiscalizacao
    const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

    //State das etapas do fluxo administrativo
    const [listEtapas, setListEtapas] = useState([]);

    //State da lista de infrações resultante da consulta
    const [listaInfracoes, setListaInfracoes] = useState([]);

    //Estado de controle dos itens selecionados para envio
    const [itensParaEnviarCobranca, setItensParaEnviarCobranca] = useState([]);

    //Estado para exibir o componente de envio em lote
    const [visibleEnviarLote, setVisibleEnviarLote] = useState(false);

    const [envioLoteEmail, setEnvioLoteEmail] = useState({
        infracaoIds: [],
        assunto: "",
        conteudo: "",
        imagensConteudo: [],
        atualizarBoleto: "true"
    });

    const [errorsEnvioLoteEmail, setErrorsEnvioLoteEmail] = useState({});

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //Estado de controle dos campos obrigatorios
    const [campos] = useState([
        objCampo({ name: "tipoBusca", required: true }),
        objCampo({ name: "statusBoleto", required: true }),
    ]);

    const datatipoBusca = [
        { value: "Data de Infração", label: "Data de Infração" },
        { value: "Data do Boleto", label: "Data do Boleto" },
        { value: "Vencimento do Boleto", label: "Vencimento do Boleto" },
    ];

    const dataStatusBoleto = [
        { value: "Todos", label: "Todos" },
        { value: "Registrado", label: "Registrado" },
        { value: "Cancelado", label: "Cancelado" },
        { value: "Vencido", label: "Vencido" },
        { value: "Liquidado", label: "Liquidado" },
    ];

    const loadTipoDeFiscalizacao = () => {
        setLoading(true);
        tipoDeFiscalizacao_api.getList()
            .then(response => {
                response.data.map(value => {
                    value.value = value.id;
                    value.label = value.identificacao;
                    return value;
                })
                //Sem a opção "Todos": nenhum tipo selecionado já significa todos os tipos
                setListTipoDeFiscalizacao(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    };

    const loadEtapas = async () => {
        setLoading(true);
        try {
            const { data } = await roteiroDeFiscalizacao_api.GetAllFiscalizacaoEtapas();
            const etapas = (data ?? []).flatMap(roteiro =>
                (roteiro.etapas ?? []).map(etapa => ({
                    value: etapa.id.toString(),
                    label: `${roteiro.identificacao} - ${etapa.descricao}`
                }))
            );
            setListEtapas([{ value: "0", label: "Todas" }, ...etapas]);
        } catch (err) {
            showMessage("Error", err?.message ?? "Error na operação.", "error", null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadTipoDeFiscalizacao();
        loadEtapas();
    }, []);

    function onchageCheckedInfracao(infracao) {
        let _itens;
        if (itensParaEnviarCobranca.some((value) => value.fiscalizacaoInfracao_Id === infracao.fiscalizacaoInfracao_Id))
            _itens = itensParaEnviarCobranca.filter((value) => value.fiscalizacaoInfracao_Id !== infracao.fiscalizacaoInfracao_Id);
        else
            _itens = [...itensParaEnviarCobranca, infracao];

        setItensParaEnviarCobranca(_itens);
        setEnvioLoteEmail((prev) => ({
            ...prev,
            infracaoIds: _itens.map(({ fiscalizacaoInfracao_Id }) => fiscalizacaoInfracao_Id)
        }));
    }

    //Cabeçalhos da lista de infrações
    const headers = [
        {
            value: "Selecionar",
            objectValue: "Selecionar",
            align: "left",
            options: {
                filter: false,
                customHeadRender: ({ index, ...column }) => {
                    const allChecked = listaInfracoes.length > 0 && itensParaEnviarCobranca.length === listaInfracoes.length;

                    return (
                        <th key={index} className="MuiTableCell-root MuiTableCell-head" style={{ padding: "16px" }}>
                            <div className="d-flex align-items-center justify-content-center gap-2" style={{ color: "#666" }}>
                                <Input
                                    style={{ border: "1px solid #666", padding: "4px" }}
                                    type="checkbox"
                                    name="selectAll"
                                    onChange={(e) => {
                                        const _itens = e.target.checked ? [...listaInfracoes] : [];
                                        setItensParaEnviarCobranca(_itens);
                                        setEnvioLoteEmail(prev => ({
                                            ...prev,
                                            infracaoIds: _itens.map(item => item.fiscalizacaoInfracao_Id)
                                        }));
                                    }}
                                    checked={allChecked}
                                />
                                <span>{column.label}</span>
                            </div>
                        </th>
                    );
                },
                customBodyRenderLite: (dataIndex) => {
                    const item = listaInfracoes[dataIndex];
                    return (
                        <div className="d-flex align-items-center justify-content-center">
                            <Input
                                style={{ border: "1px solid #666" }}
                                type="checkbox"
                                onChange={() => onchageCheckedInfracao(item)}
                                checked={itensParaEnviarCobranca.some(
                                    value => value.fiscalizacaoInfracao_Id === item.fiscalizacaoInfracao_Id
                                )}
                            />
                        </div>
                    );
                },
            },
        },
        { value: "Número Infração", objectValue: "numeroInfracao", align: "left" },
        { value: "Nome do Infrator", objectValue: "nomeInfrator", align: "left" },
        { value: "Identificação da Infração", objectValue: "infracao_Identificacao", align: "left" },
        { value: "Tipo de Fiscalização", objectValue: "tipoFiscalizacao", align: "left" },
        { value: "Número Guia", objectValue: "numeroGuia", align: "left" },
        { value: "Status do Boleto", objectValue: "statusBoleto", align: "left" },
        {
            value: "Valor da Multa", objectValue: "valorMulta", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    const valor = listaInfracoes[dataIndex]?.valorMulta;
                    return <>{(valor ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</>
                }
            }
        },
        {
            value: "Data de Vencimento", objectValue: "dataVencimento", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{moment(listaInfracoes[dataIndex]?.dataVencimento).format("DD/MM/YYYY")}</>
                }
            }
        },
    ];

    const onChangeMultiSelect = criarOnChangeMultiSelect({
        state: consulta,
        setState: setConsulta
    });

    const onChangeSelect = (value, e) => {
        const _consulta = {
            ...consulta,
            [e.name]: value ? value.value.toString() : null,
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === e.name);
        const fieldError = validarCampos(_consulta, _campos);

        const _errors = { ...errors };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setConsulta(_consulta);
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setConsulta({
            ...consulta,
            [name]: value
        })
    }

    const handleConsulta = async () => {
        const _errors = validarCampos(consulta, campos);
        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return true;

        setLoading(true);
        try {
            const { data } = await gereciamentoArrecadacao_api.GetConsultaGerenciamentoArrecadacao(consulta);

            //A consulta devolve os boletos agrupados por status — achata e remove duplicidade por infração
            const infracoes = (data?.tipoArrecadacao ?? [])
                .flatMap(card => card.listaFiscalizacaoInfratores ?? [])
                .filter((item, index, lista) =>
                    lista.findIndex(x => x.fiscalizacaoInfracao_Id === item.fiscalizacaoInfracao_Id) === index
                );

            setListaInfracoes(infracoes);
            setItensParaEnviarCobranca([]);
            setEnvioLoteEmail(prev => ({ ...prev, infracaoIds: [] }));
        }
        catch (err) {
            showMessage("Error", err?.message ?? "Erro na operação.", "error", null);
        }
        finally {
            setLoading(false);
        }
    };

    if (visibleEnviarLote) {
        return <EnviarCobrancaEmLote
            handleReturn={() => {
                setVisibleEnviarLote(false);
            }}
            envioLoteEmail={envioLoteEmail}
            setEnvioLoteEmail={setEnvioLoteEmail}
            listaEnviarCobranca={itensParaEnviarCobranca}
            setListaEnviarCobranca={setItensParaEnviarCobranca}
            setErrors={setErrorsEnvioLoteEmail}
            errors={errorsEnvioLoteEmail}
            mostrarOpcaoAtualizarBoleto={true}
        />
    }

    return (
        <>
            <h4 className='text-secondary m-0'>Emissão de Boletos em Lote</h4>

            <Row className='mt-3'>
                <Col md={12} lg={3}>
                    <TextField
                        type={"select"}
                        name={"tipoBusca"}
                        label={"* Tipo de Busca"}
                        searchable
                        options={datatipoBusca}
                        onChange={onChangeSelect}
                        value={datatipoBusca.filter(value => value.value == consulta.tipoBusca)}
                        invalid={!!errors.tipoBusca}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        type={"date"}
                        name={"dataInicial"}
                        label={"* Data Inicial"}
                        onChange={onChange}
                        value={consulta.dataInicial}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        type={"date"}
                        name={"dataFinal"}
                        label={"* Data Final"}
                        onChange={onChange}
                        value={consulta.dataFinal}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        type={"select"}
                        name={"statusBoleto"}
                        label={"* Status do Boleto"}
                        searchable
                        options={dataStatusBoleto}
                        onChange={onChangeSelect}
                        value={dataStatusBoleto.filter(value => value.value == consulta.statusBoleto)}
                        invalid={!!errors.statusBoleto}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        type={"select"}
                        name={"tipoFiscalizacao_Ids"}
                        label={"Tipo de Fiscalização"}
                        placeholder={"Todos"}
                        multiple
                        options={listTipoDeFiscalizacao}
                        onChange={onChangeMultiSelect}
                        value={listTipoDeFiscalizacao.filter(value => (consulta.tipoFiscalizacao_Ids ?? []).includes(value.value))}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        type={"select"}
                        name={"roteiroFiscalizacaoEtapa_Id"}
                        label={"Etapa do Fluxo Administrativo"}
                        searchable
                        options={listEtapas}
                        onChange={onChangeSelect}
                        value={listEtapas.filter(value => value.value == consulta.roteiroFiscalizacaoEtapa_Id)}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        type={"text"}
                        name={"numeroInfracao"}
                        label={"Número da infração"}
                        onChange={onChange}
                        value={consulta.numeroInfracao}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        type={"text"}
                        name={"nome"}
                        label={"Nome"}
                        onChange={onChange}
                        value={consulta.nome}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        type={"text"}
                        name={"bairro"}
                        label={"Bairro"}
                        onChange={onChange}
                        value={consulta.bairro}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        type={"text"}
                        name={"logradouro"}
                        label={"Logradouro"}
                        onChange={onChange}
                        value={consulta.logradouro}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        type={"text"}
                        name={"numero"}
                        label={"Numero"}
                        mask={mascaras.numeroMask}
                        onChange={onChange}
                        value={consulta.numero}
                    />
                </Col>
            </Row>

            <div className='d-flex justify-content-center gap-3'>
                <div>
                    <Button
                        color='primary'
                        className='text-white fw-bold w-100'
                        onClick={() => handleConsulta()}
                    >
                        <FontAwesomeIcon icon={faFilter} /> Filtrar
                    </Button>
                </div>
                {itensParaEnviarCobranca.length > 0 &&
                    <div>
                        <Button
                            color='warning'
                            className='text-white fw-bold w-100'
                            onClick={() => setVisibleEnviarLote(true)}
                        >
                            <FontAwesomeIcon icon={faMailBulk} /> Enviar Boletos em Lote
                        </Button>
                    </div>
                }
            </div>

            {listaInfracoes.length > 0 &&
                <Row className='mt-2'>
                    <Col lg={12}>
                        <TabelaListagem
                            actions={[]}
                            title={`Boletos`}
                            options={{ print: false, search: true, pagination: true, viewColumns: false }}
                            headers={headers}
                            items={listaInfracoes}
                        />
                    </Col>
                </Row>
            }
        </>
    )
}
